import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TPostDepositRuleRequestSchema,
  TPostDepositRuleResponseSchema,
} from "./postDepositRule.schema";

export const postDepositRule = (axios: IAxiosInstance) => {
  return async (data: TPostDepositRuleRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TPostDepositRuleResponseSchema>
    >(`/api/deposit-rules`, data);

    return response.data;
  };
};
